import { render } from "./BaseFlashMsgWrapper.vue?vue&type=template&id=178d75f4&scoped=true"
import script from "./BaseFlashMsgWrapper.vue?vue&type=script&lang=js"
export * from "./BaseFlashMsgWrapper.vue?vue&type=script&lang=js"

import "./BaseFlashMsgWrapper.vue?vue&type=style&index=0&id=178d75f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178d75f4"]])

export default __exports__